import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';
import ErrorPage 	from '../common/error/_ErrorPage.jsx';

export default class DSANotice extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
            strDSAUpdateDate: ""
        ,   strDSAStartDate: ""
        ,   strDSAEndDate: ""
        ,   nActiveUsers: ""
        ,   nActiveStudioUsers: ""
        ,   isLoaded: false
        ,   isError: false
		}
	}
    componentDidMount() 
	{
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];

        blapp.dsa_notice.getDSANotice(
		).then(
	    	( data ) =>
	    	{
	        	const ud = new Date( data.dtUpdate );
                const strDSAUpdateDate = ud.getDate() + " " + monthNames[ud.getMonth()] + ", " + (ud.getYear() + 1900);
                const strDSAStartDate = monthNames[data.nMonthFrom - 1] + " 1, " + data.nYearFrom;
                const ed = new Date( data.nYearTo, data.nMonthTo, 0 );
                const strDSAEndDate = monthNames[ed.getMonth()] + " " + ed.getDate() + ", " + (ed.getYear() + 1900);
                const activeUsers = data.nActiveUsers.toLocaleString("en-US");
                const activeStudioUsers = (data.nActiveStudioUsers == null)?0:data.nActiveStudioUsers.toLocaleString("en-US");
                this.setState({strDSAStartDate: strDSAStartDate, strDSAEndDate: strDSAEndDate, strDSAUpdateDate: strDSAUpdateDate, nActiveUsers: activeUsers, nActiveStudioUsers: activeStudioUsers, isLoaded: true});
	        }
	    ).catch(
	    	( err ) =>
	    	{
	    		this.setState({isError:true});
	    	}
	    );
        
    }

	render() {
        
		return(
            <div className="main l-border-round overflow-hidden">
                <div className="main__content">
                    {this.renderHeader()}

                    {(this.state.isLoaded)&&this.renderContent()}
                </div>
            </div>
        )
	}

    renderHeader() {
        return(
            <header className="l-pad--xl">
                <h1 className="text--mxl-title l-border--bottom l-pad-bottom">Digital Services Act Notice</h1>
            </header>
        )
    }

    renderContent() {
        if (this.state.isError) {
            return(this.renderError());
        }
        return (
            <div className="l-pad--xl l-pad-top--null dsa-notice__content l-margin-bottom--xl">
                <p className="l-margin-bottom">
                    <span className="text--italic">The Digital Services Act</span> (DSA) regulates the obligations of digital services that act as intermediaries in their role of connecting consumers with goods, services, and content. This includes online platforms and marketplaces, among others. The DSA gives better protection to users and to fundamental rights online, establishes a transparency and accountability framework for online platforms and provides a single, uniform framework across the European Union (EU).
                </p>
                <p className="l-margin-bottom">
                    The DSA entered into force on 16 November 2022.
                </p>

                <p className="l-margin-bottom">
                    <strong>Information on active monthly users as of {this.state.strDSAEndDate}</strong>
                </p>

                <p className="l-margin-bottom">
                    Under Article 24 (2) of the DSA, online platforms are required to publish ‘information on the average monthly active recipients of the service’ in the EU.
                </p>

                <p className="l-margin-bottom">
                    We have calculated the average monthly active recipients of our online platforms and marketplace service in the EU based on the period <strong>{this.state.strDSAStartDate} to {this.state.strDSAEndDate}</strong> in accordance with Recital 77 of the DSA. During this period the average number of monthly active recipients on BrickLink in the EU was <strong>{this.state.nActiveUsers}</strong> and the average number of monthly active recipients on Studio in the EU was <strong>{this.state.nActiveStudioUsers}</strong>.
                </p>
                
                <p className="l-margin-bottom">
                    We will continue to monitor the number of average monthly active recipients of our online platforms and marketplace service in the EU and will publish updated information later in 2023, in accordance with Article 24 (2).
                </p>

                <p className="l-margin-bottom">
                    If you are a Trusted Flagger, submit your report to <a href="mailto:bricklink@support.lego.com">bricklink@support.lego.com</a>
                </p>
            </div>
        )
    }

    renderError() {
        const errorMsg = ["There was an error loading the page.", "Please try again"];
        return(
            <div className="l-pad--xl l-pad-top--null dsa-notice__content l-margin-bottom--xl l-margin-x--auto">
                <ErrorPage errorMsg={errorMsg} button={{name:"Reload page", action: this.buttonAction, class: "btn btn--cta l-full-width"}} />
            </div>
        )
    }

    buttonAction() {
        console.log("button action");
    }
	
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<DSANotice/>
						,	document.getElementById( 'bl-dsa-notice' )
						);
	}
);
